import React, { FC, useContext } from 'react';

import { Separator } from '@smartshell/ui-kit';

import { SettingsBlock, SettingsFrame } from 'components';
import { FeatureHOC } from 'features';
import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import {
  CallAdmin,
  ClubReview,
  PeripheralSettings,
  SelfHostChange,
  TransplantHalls,
  TransplantHallsActive,
  Tips,
  LightShell,
  PlayerRating,
} from './components';

export const ClientCapabilities: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { feedbackEnabled },
    },
  } = useContext(SettingsContext);

  return (
    <>
      <SettingsBlock title={t('settings.shell.client.title')}>
        <FeatureHOC alias="lite_shell" strategy="hide">
          <SettingsFrame>
            <LightShell />
          </SettingsFrame>
        </FeatureHOC>

        <SettingsFrame>
          <div>
            <ClubReview />
            {feedbackEnabled && (
              <FeatureHOC alias="tips">
                <Separator style={{ margin: '16px 0' }} />
                <Tips />
              </FeatureHOC>
            )}
          </div>
        </SettingsFrame>

        <SettingsFrame>
          <SelfHostChange />
          <Separator />
          <TransplantHalls />
          <Separator />
          <TransplantHallsActive />
        </SettingsFrame>

        <SettingsFrame>
          <CallAdmin />
        </SettingsFrame>

        <SettingsFrame>
          <PeripheralSettings />
        </SettingsFrame>

        <SettingsFrame>
          <PlayerRating />
        </SettingsFrame>
      </SettingsBlock>
    </>
  );
};
